/**
 * Formats a number to show decimals only when necessary
 * @param {number} value - The number to format
 * @param {number} maxDecimals - Maximum number of decimal places (default: 2)
 * @returns {string} Formatted number string
 */
const FormatNumber = (value, maxDecimals = 2) => {
    if (value === null || value === undefined || isNaN(value)) {
        return '0';
    }
    
    // Convert to number if it's a string
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) {
        return '0';
    }
    
    // Format with maxDecimals, then remove trailing zeros
    const formatted = num.toFixed(maxDecimals);
    
    // Remove trailing zeros and decimal point if not needed
    return formatted.replace(/\.?0+$/, '');
};

export default FormatNumber;
